
<div class="tooltip"><ng-content></ng-content>
    <span class="tooltiptext" #tooltipText
    [ngClass]="customClasses" [style.width.px]="width">
        <ng-container *ngTemplateOutlet="template; context: data"></ng-container>
    </span>
</div>